let urls = [
  "https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxK.woff2",
  "https://fonts.gstatic.com/l/font?kit=KFOmCnqEu92Fr1Me4GZNCzcPK4I&skey=a0a0114a1dcab3ac&v=v20",
  "https://speed.cloudflare.com/__down?bytes=0"
], main_candidate = urls[1];

export {urls as LatencyCandidates}
export {main_candidate}
